import { Injectable } from "@angular/core";

@Injectable({
    providedIn: 'root'
})
export class PartySignupTabsService{
    public selectedTab:string|null = 'paid';
}